// Written out as complete class names rather than built from a `bg-${x}-500`
// template so Tailwind's content scanner can see them.
export const AVATAR_COLORS = [
  "bg-gray-500",
  "bg-blue-500",
  "bg-green-500",
  "bg-yellow-500",
  "bg-red-500",
  "bg-purple-500",
  "bg-teal-500",
  "bg-orange-500",
] as const;

// FNV-1a. Nothing here is security-sensitive -- it only has to spread similar
// keys (person1@, person2@, ...) across eight buckets, which a simple additive
// hash does poorly.
function hash(key: string): number {
  let h = 2166136261;
  for (let i = 0; i < key.length; i++) {
    h ^= key.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return h >>> 0;
}

// Picks a stable background color for a user's initials circle. Keyed on the
// email rather than the initials so two people who share initials still get
// different colors, and so a user's color doesn't change the day they set a
// name. Always pair with text-white.
export function avatarColorFor(key: string): string {
  return AVATAR_COLORS[hash(key.trim().toLowerCase()) % AVATAR_COLORS.length];
}
